import { getExamQuestionCount } from '~/utils/utils';

export const PRICING_FEATURES = [
  `${getExamQuestionCount()}+ High Yield Questions`,
  'Expert Explanations & Tips',
  'Personal AI Tutor',
  'Daily Goal',
  'Personalized Study Sessions',
  'Customizable Practice Modes',
  'Dark Mode',
  'Notepad',
  'On your PC, Tablet & Mobile Devices',
] as const;
